import { createSlice } from "@reduxjs/toolkit";

export const suppliersSlice = createSlice({
    name: 'suppliers',
    initialState: [],
    reducers: {
        empty: state => {
            return []
        },
        setSuppliers: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload
            }
        },
        add: (state, action) => {
            state.push(action.payload);
            return state;
        },
        update: (state, action) => {
            const foundedIndex = state.findIndex((supplier) => supplier.id === action.payload?.id);
            if (foundedIndex !== -1) {
                state[foundedIndex] = action.payload
            }
            return state
        },
        remove: (state, action) => {
            const foundedIndex = state.findIndex((supplier) => supplier.id === action.payload?.id);
            if (foundedIndex !== -1) {
                state.splice(foundedIndex, 1)
            }
            return state
        }
    }
});

export const {
    setSuppliers,
    empty,
    add,
    update,
    remove
} = suppliersSlice.actions;

export default suppliersSlice.reducer;
